export function initializePlansPaymentModal() {
  const root = document.querySelector("[data-plans-payment-root]");

  if (!root || root.dataset.plansPaymentInitialized === "true") {
    return;
  }

  if (typeof window.Stripe !== "function") {
    return;
  }

  const publishableKey = root.dataset.stripePublishableKey;
  const createPaymentIntentPath = root.dataset.createPaymentIntentPath;
  const successPath = root.dataset.successPath;
  const customerEmail = root.dataset.customerEmail;

  if (!publishableKey || !createPaymentIntentPath || !successPath) {
    return;
  }

  const stripe = window.Stripe(publishableKey);
  const modal = root.querySelector("[data-payment-modal]");
  const closeModalButton = root.querySelector("[data-close-payment-modal]");
  const paymentForm = root.querySelector("[data-payment-form]");
  const paymentElementContainer = root.querySelector("[data-payment-element]");
  const submitButton = root.querySelector("[data-payment-submit]");
  const buttonText = root.querySelector("[data-payment-button-text]");
  const spinner = root.querySelector("[data-payment-spinner]");
  const errorMessage = root.querySelector("[data-payment-error]");
  const selectedPlanName = root.querySelector("[data-selected-plan-name]");
  const selectedPlanPrice = root.querySelector("[data-selected-plan-price]");
  const subscriptionNotice = root.querySelector('[data-payment-notice="subscription"]');
  const bankTransferNotice = root.querySelector('[data-payment-notice="bank_transfer"]');

  if (
    !modal ||
    !closeModalButton ||
    !paymentForm ||
    !paymentElementContainer ||
    !submitButton ||
    !buttonText ||
    !spinner ||
    !errorMessage ||
    !selectedPlanName ||
    !selectedPlanPrice
  ) {
    return;
  }

  const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content;
  let elements;
  let currentSubscriptionId = null;

  const setLoading = (isLoading) => {
    submitButton.disabled = isLoading;
    spinner.classList.toggle("d-none", !isLoading);
    buttonText.classList.toggle("d-none", isLoading);
  };

  const togglePlanNotice = (planType) => {
    subscriptionNotice?.classList.add("d-none");
    bankTransferNotice?.classList.add("d-none");

    if (planType === "annual") {
      subscriptionNotice?.classList.remove("d-none");
    } else if (["annual_one_time", "single", "annual_add_on"].includes(planType)) {
      bankTransferNotice?.classList.remove("d-none");
    }
  };

  const resetModalState = () => {
    modal.classList.remove("d-flex");
    modal.classList.add("d-none");
    document.body.classList.remove("overflow-hidden");
    errorMessage.textContent = "";
    errorMessage.classList.add("d-none");
    paymentElementContainer.innerHTML = "";
    elements = null;
    currentSubscriptionId = null;
    setLoading(false);
  };

  root.querySelectorAll(".plan-btn").forEach((button) => {
    button.addEventListener("click", async () => {
      const originalDisabledState = button.disabled;
      button.disabled = true;

      togglePlanNotice(button.dataset.plan);
      selectedPlanName.textContent = button.dataset.planName || "";
      selectedPlanPrice.textContent = button.dataset.planPrice || "";
      errorMessage.textContent = "";
      errorMessage.classList.add("d-none");
      paymentElementContainer.innerHTML = "";

      try {
        const response = await fetch(createPaymentIntentPath, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "X-CSRF-Token": csrfToken || "",
          },
          body: JSON.stringify({ plan_type: button.dataset.plan }),
        });

        const data = await response.json();
        if (data.error) {
          throw new Error(data.error);
        }

        currentSubscriptionId = data.subscriptionId;
        elements = stripe.elements({
          clientSecret: data.clientSecret,
          appearance: { theme: "stripe" },
        });

        const paymentElement = elements.create("payment", {
          paymentMethodOrder: ["card", "customer_balance"],
          layout: "tabs",
          fields: { billingDetails: { email: "never" } },
        });

        paymentElement.mount(paymentElementContainer);
        modal.classList.remove("d-none");
        modal.classList.add("d-flex");
        document.body.classList.add("overflow-hidden");
      } catch (error) {
        alert(`エラー: ${error.message}`);
      } finally {
        button.disabled = originalDisabledState;
      }
    });
  });

  closeModalButton.addEventListener("click", resetModalState);

  paymentForm.addEventListener("submit", async (event) => {
    event.preventDefault();

    if (!elements) {
      return;
    }

    setLoading(true);

    let returnUrl = `${window.location.origin}${successPath}`;
    if (currentSubscriptionId) {
      returnUrl += `?subscription_id=${currentSubscriptionId}`;
    }

    const { error } = await stripe.confirmPayment({
      elements,
      confirmParams: {
        return_url: returnUrl,
        payment_method_data: {
          billing_details: { email: customerEmail || "" },
        },
      },
    });

    if (error) {
      errorMessage.textContent = error.message;
      errorMessage.classList.remove("d-none");
      setLoading(false);
    }
  });

  root.dataset.plansPaymentInitialized = "true";
}
